import { _ as __rest, a as __assign } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import React__default from 'react';

var styles = {"container":"Grid_container_0daf084c","fullWidth":"Grid_fullWidth_0daf084c","debug":"Grid_debug_0daf084c","row":"Grid_row_0daf084c","col":"Grid_col_0daf084c","collapse":"Grid_collapse_0daf084c","grow":"Grid_grow_0daf084c","col-1":"Grid_col-1_0daf084c","col-2":"Grid_col-2_0daf084c","col-3":"Grid_col-3_0daf084c","col-4":"Grid_col-4_0daf084c","col-5":"Grid_col-5_0daf084c","col-6":"Grid_col-6_0daf084c","col-7":"Grid_col-7_0daf084c","col-8":"Grid_col-8_0daf084c","col-9":"Grid_col-9_0daf084c","col-10":"Grid_col-10_0daf084c","col-11":"Grid_col-11_0daf084c","col-12":"Grid_col-12_0daf084c","offset-1":"Grid_offset-1_0daf084c","offset-2":"Grid_offset-2_0daf084c","offset-3":"Grid_offset-3_0daf084c","offset-4":"Grid_offset-4_0daf084c","offset-5":"Grid_offset-5_0daf084c","offset-6":"Grid_offset-6_0daf084c","offset-7":"Grid_offset-7_0daf084c","offset-8":"Grid_offset-8_0daf084c","offset-9":"Grid_offset-9_0daf084c","offset-10":"Grid_offset-10_0daf084c","offset-11":"Grid_offset-11_0daf084c"};

var Grid = function (_a) {
    var _b;
    var className = _a.className, isDebug = _a.isDebug, fullWidth = _a.fullWidth, children = _a.children, otherProps = __rest(_a, ["className", "isDebug", "fullWidth", "children"]);
    return (React__default.createElement("div", __assign({ className: classNames(styles.container, className, (_b = {},
            _b[styles.debug] = isDebug,
            _b[styles.fullWidth] = fullWidth,
            _b)) }, otherProps), children));
};

var Row = function (_a) {
    var _b;
    var className = _a.className, collapseMargin = _a.collapseMargin, children = _a.children, otherProps = __rest(_a, ["className", "collapseMargin", "children"]);
    return (React__default.createElement("div", __assign({ className: classNames(styles.row, (_b = {}, _b[styles.collapse] = collapseMargin, _b), className) }, otherProps), children));
};

var Col = function (_a) {
    var _b;
    var className = _a.className, offset = _a.offset, size = _a.size, children = _a.children, otherProps = __rest(_a, ["className", "offset", "size", "children"]);
    return (React__default.createElement("div", __assign({ className: classNames(styles.col, className, (_b = {},
            _b[styles["col-".concat(size)]] = !!size,
            _b[styles["offset-".concat(offset)]] = !!offset,
            _b[styles.grow] = !size,
            _b)) }, otherProps), children));
};

export { Col, Grid, Row };
